import * as React from 'react';

// The bar at the top of every screen on the rail (Home, Openings,
// Middlegame, Ending, Library, Settings): the screen and the period on the
// left, "Openings · Last 30 days", and the actions on the right: the import,
// which also shows the automatic scan's progress. An optional caption sits under the bar,
// muted: what the screen's numbers cover. The same bar on every screen, so
// the title and the buttons read the same everywhere.

export interface DashboardHeaderProps {
  /** The screen's name: "Home", "Openings", "Middlegame". */
  screen: string;
  /** The period every number on the screen covers; `null` for a screen without numbers (Settings). */
  period?: string | null;
  /** A muted line under the bar, e.g. "188 games · 121 scanned". */
  caption?: React.ReactNode;
  /** The right-hand side: the import. */
  action?: React.ReactNode;
}

export const DashboardHeader: React.FC<DashboardHeaderProps> = ({ screen, period = 'Last 30 days', caption, action }) => (
  <header className="dashboard-header">
    <div className="dashboard-header-bar">
      <h1 className="dashboard-header-title">
        {screen}
        {period !== null && <span className="dashboard-header-period"> · {period}</span>}
      </h1>
      {action && <div className="dashboard-header-action">{action}</div>}
    </div>
    {caption && <p className="dashboard-header-caption">{caption}</p>}
  </header>
);
